<template>
  <div class="create-pricing-dialog">
    <el-dialog
      :title="'Create Pricing'"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :width="device === 'mobile' ? '80%' : '60%'"
    >
      <el-form
        :model="pricingForm"
        id="pricingForm"
        ref="pricingForm"
        label-width="150px"
        size="small"
        :rules="pricingFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
        v-loading="loading"
      >
        <el-tabs v-model="tabActiveName">
          <el-tab-pane label="Info" name="tab1">

            <el-form-item label="Pricing group" prop="pricing_group">
              <el-select
                v-model="pricingForm.pricing_group"
                placeholder="Select pricing group"
              >
                <el-option
                  v-for="item in pricingHeader"
                  :key="item.id"
                  :label="item.header_text"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            
            <el-form-item label="Active" prop="active">
              <el-checkbox v-model="pricingForm.active"></el-checkbox>
            </el-form-item>

            <el-form-item label="Pricing Code" prop="pricing_code">
              <el-input
                v-model="pricingForm.pricing_code"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="Text" prop="text">
              <el-input
                v-model="pricingForm.text"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="Fee Text" prop="fee_text">
              <el-input
                v-model="pricingForm.fee_text"
                autocomplete="off"
              ></el-input>
            </el-form-item>

          </el-tab-pane>

          <el-tab-pane label="Fee" name="tab2">

            <el-row :gutter="20">
              <el-col :span="12">
                <el-divider content-position="left">Fee Collect from customer</el-divider>
                <el-form-item label="Cost" prop="cost">
                  <el-input
                    type="number"
                    v-model="pricingForm.cost"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>

                <!-- <el-form-item label="Currency" prop="currency">
                  <el-select
                    v-model="pricingForm.currency"
                    placeholder="Select"
                  >
                    <el-option label="GBP" value="GBP"></el-option>
                    <el-option label="EUR" value="EUR"></el-option>
                    <el-option label="USD" value="USD"></el-option>
                  </el-select>
                </el-form-item> -->

                <el-form-item label="Is percent" prop="is_percent">
                  <el-checkbox v-model="pricingForm.is_percent"></el-checkbox>
                </el-form-item>

                <el-form-item label="Percent" prop="percent">
                  <el-input
                    type="number"
                    v-model="pricingForm.percent"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-divider content-position="left">Fee Collect from agent</el-divider>
                <el-form-item label="Fee" prop="system_fee">
                  <el-input
                    type="number"
                    v-model="pricingForm.system_fee"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>

                <!-- <el-form-item label="Fee Currency" prop="system_fee_currency">
                  <el-select
                    v-model="pricingForm.system_fee_currency"
                    placeholder="Select"
                  >
                    <el-option label="GBP" value="GBP"></el-option>
                    <el-option label="EUR" value="EUR"></el-option>
                    <el-option label="USD" value="USD"></el-option>
                  </el-select>
                </el-form-item> -->

                <el-form-item label="Fee is percent" prop="system_fee_ispercent">
                  <el-checkbox v-model="pricingForm.system_fee_ispercent"></el-checkbox>
                </el-form-item>

                <el-form-item label="Fee percent" prop="system_fee_percent">
                  <el-input
                    type="number"
                    v-model="pricingForm.system_fee_percent"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>



          </el-tab-pane>


          <el-tab-pane label="Sync to Project" name="tab3">
            <el-tree
            v-if="companyData"
              :props="props"
              :load="loadNode"
              default-expand-all
              ref="tree"
              lazy
              show-checkbox
              node-key="id">
            </el-tree>
          </el-tab-pane>
        </el-tabs>

        <div class="dialog-footer">
          <el-button
            :loading="submiting"
            type="primary"
            @click="submitAddPricing()"
            >Submit</el-button
          >
          <el-button @click="dialogShow = false">Cancel</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getCompany } from "@/api/company";
import { getProjectByCompany } from "@/api/project";
import { addPricingTemplate, getPricingHeader } from "@/api/pricing";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      loading: true,
      submiting: false,
      dialogShow: false,
      errMsg: "",
      tabActiveName: "tab1",
      userData: [],
      pricingHeader: [],
      pricingForm: this.model(),
      companyData: null,
      props: {
          label: 'label',
          children: 'zones'
        },
      pricingFormRules: {
        pricing_group: [
          {
            required: true,
            message: "Please select pricing group",
            trigger: "blur",
          },
        ],
        pricing_code: [
          {
            required: true,
            message: "Please enter pricing code",
            trigger: "blur",
          },
        ],
        text: [
          {
            required: true,
            message: "Please enter pricing text",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    model() {
      return {
        pricing_group: null,
        pricing_code: "",
        text: "",
        cost: 0,
        currency: "GBP",
        is_percent: false,
        percent: 1,
        active: true,
        fee_text: "",
        system_fee: 0,
        system_fee_currency: "GBP",
        system_fee_ispercent: false,
        system_fee_percent: 0,
        project: "",
      };
    },
    showDialog() {
      this.dialogShow = true;
      this.loading = true;
      this.pricingForm = this.model();
      if(this.$refs.tree) this.$refs.tree.setCheckedKeys([]);
      this.tabActiveName = "tab1"
      this.getPricingHeader();
    },

    getCompany(){
      getCompany().then(({result, data})=>{
        this.loading = false;
        if(result){
          this.companyData = data
        }
      })
    },

    getPricingHeader() {
      getPricingHeader().then(({ result, data }) => {
        
        if (result) {
          this.pricingHeader = data;
          this.getCompany();
          
        }
      });
    },
    companySetup(data){
      let setup = []
      data.forEach((item)=>{
        setup.push({
          id: item.uid,
          label: item.company_name
        })
      })

      return setup;
    },

    projectSetup(data){
      let setup = []
      data.forEach((item)=>{
        setup.push({
          id: item.uid,
          label: item.project_name,
          leaf: true
        })
      })

      return setup;
    },

    getProjectActive(){
      let data = this.$refs.tree.getCheckedNodes();
      let projectSelect = []
      data.forEach((item)=>{
        if(item.leaf){
          projectSelect.push(item.id)
        }
      })

      return projectSelect.join(',')
    },

    loadNode(node, resolve) {

      if (node.level === 0) {
          return resolve(this.companySetup(this.companyData));
      }

      if (node.level === 1){
        getProjectByCompany(node.key).then(({result, data})=>{
          if(result){
            resolve(this.projectSetup(data))
          }else{
            resolve([])
          }
        })
      }

      if(node.level > 1) return resolve([])

    },


    addPricingTemplate(){
      this.submiting = true
      this.pricingForm.project = this.getProjectActive()
      addPricingTemplate(this.pricingForm).then(({result})=>{
        this.submiting = false
        if(result){
          this.$notify({
            title: 'Success',
            message: `Update Project successfully`,
            type: 'success',
            duration: 2000
          });
          this.handleClose()
          this.$emit("created", true);
        }else{
          this.errMsg = message
        }
      })
    },

    submitAddPricing(){
      
      this.$refs.pricingForm.validate((valid) => {
        if (valid) {
          this.addPricingTemplate()
        }else{
          this.tabActiveName = 'tab1'
        }
      });
      
    },

    handleClose() {
      this.dialogShow = false;
    },
  },
};
</script>

<style lang="scss">
.create-pricing-dialog{
  input[type="number"]{
    width: 100px;
    text-align: right !important;
  }

  .el-tabs__content{
    padding: 20px 10px;
  }

  .dialog-footer{
    padding: 10px 0;
    text-align: right;
  }
}
</style>